module.exports = __webpack_public_path__ + "img/ai-search-2.6e90fcc7.jpg";